import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./catalog-payable-scheme.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./catalog-payable-scheme.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";


@Injectable()
export class CatalogPayableSchemeEffects {


  createServiceCatalogPayableScheme$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createCatalogPayableSchemes),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_CATALOG_PAYABLE_ITEMS,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertCatalogPayableScheme({ catalogPayableScheme: result?.data }));
              await this.notificationService.successMessage('Created Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  updateServicePercentageScheme$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.editCatalogPayableSchemes),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_CATALOG_PAYABLE_ITEMS,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertCatalogPayableScheme({ catalogPayableScheme: result?.data }));
              await this.notificationService.successMessage('Updated Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteServicePercentageScheme$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeCatalogPayableSchemes),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_CATALOG_PAYABLE_ITEMS,
        variables: {
          itemUniqueId: action?.itemUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteCatalogPayableScheme({ id: action.id }));
              await this.notificationService.successMessage('Deleted Successfully');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getCatalogPayableSchemes$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getCatalogPayableSchemes),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_CATALOG_PAYABLE_ITEMS,
        fetchPolicy: 'network-only',
        variables: {
          catalogyUniqueId: action.catalogyUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching catalog based payable items'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadCatalogPayableSchemes({ catalogPayableSchemes: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  citizenGetInstitutionServiceCatalogItems$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetInstitutionServiceCatalogItems),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.CITIZEN_GET_INSTITUTION_SERVICE_CATALOG_ITEMS,
        fetchPolicy: 'network-only',
        variables: {
          catalogyUniqueId: action.catalogyUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching get service catalog items'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(
              fromActions.loadCatalogPayableSchemes({ catalogPayableSchemes: result?.data })
            ) : []
          }
        })
      );
    })
  ), { dispatch: false });


  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
